<template lang="pug">

  Dropdown(
    :title="team.name"
    :manual="isOpenTeamGroup"
    @isOpen="isOpenTeamGroup = $event"
  )
    template(v-slot:header)
      p.dropdown-row__count(
        :class="{'-absolute-': canEdit}"
      ) {{currentNamesUserCount(team.count)}}

      .user-team__icon-wrapper.-group-(
        v-if="canEdit"
      )
        Icon.user-team__icon(
          icon="gear"
          :class="{'-active-': false, 'user-team__icon--hover-accent' : !user.isCaptain }"
          @click.stop="!user.isCaptain ? openSettings() : undefined"
        )
        Icon.user-team__icon(
          icon="delete"
          :class="{'-active-': false, 'user-team__icon--hover-danger' : !user.isCaptain}"
          @click.stop="!user.isCaptain ? showDeleteModal() : undefined"
        )
        UiModal(
          v-model="isOpenDeleteModal"
          :destroy="true"
          @reject="unshowDeleteModal"
          @accept="deleteTeam"
        )
          p Вы действительно хотите удалить команду?
    //- TODO убрать v-if
    UserTable(
      v-if="isOpenTeamGroup"
      :team="team"
      :folderId="folderId"
    )

</template>

<script>
import { mapState } from 'vuex';
import UserTable from './components/UserTable';
import EmptyUserTable from './components/EmptyUserTable';
import Dropdown from '../Body/components/Dropdown';
import counterNameFilter from '@/filters/counterName.filter';

export default {
  components: {
    UserTable,
    EmptyUserTable,
    Dropdown
  },
  props: {
    team: {
      type: Object,
      default: () => ({})
    },
    folderId: {
      type: [Number, String],
      default: 0
    },
    autoOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpenTeamGroup: false,
      isOpenDeleteModal: false
    };
  },
  computed: {
    ...mapState('teamGroup', {
      canEdit: s => s.data.settings.canEdit
    }),
    ...mapState('auth', {
      user: s => s.data.user
    })
  },
  mounted() {
    if (this.autoOpen) {
      this.isOpenTeamGroup = true;
    }
  },
  methods: {
    currentNamesUserCount(counter) {
      const names = ['участник', 'участника', 'участников'];
      return counterNameFilter(+counter, names);
    },
    openSettings() {
      this.$store.dispatch('asides/addAside', {
        data: {
          name: 'setting-team-group',
          title: 'Настройки команды',
          subtitle: 'Отредактируйте название и назначьте капитанов',
          slotClass: '-field-',
          team: this.team
        }
      });
    },
    showDeleteModal() {
      if (+this.team.count) {
        this.$store.dispatch(
          'ajax/addMessage',
          { message: 'В команде ещё есть участники', type: 'error' },
          { root: true }
        );
      } else {
        this.isOpenDeleteModal = true;
      }
    },
    unshowDeleteModal() {
      this.isOpenDeleteModal = false;
    },
    async deleteTeam() {
      await this.$store.dispatch('teamGroup/deleteTeam', this.team.id);
      this.unshowDeleteModal();
    }
  }
};
</script>
